import React from 'react';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import BeachChairWithSun from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/BeachChairWithSun';
import PaperWithDollarSignAndBarChart from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperWithDollarSignAndBarChart';
import TwoPeopleTwoWordBubbles from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoPeopleTwoWordBubbles';
// native components
import UnderstandingProductGrouping from '../../../components/understandingProductGrouping/understandingProductGrouping';
// styles
import { ColStyled } from './styles';

export const ITEMS = [
  {
    id: 'who-we-are-better-conversations',
    icon: TwoPeopleTwoWordBubbles,
    title: 'Better conversations',
    contentAs: 'div',
    content: (
      <Typography disableBottomPadding>
        Our financial advisors are expert listeners who ask deeper questions to understand your goals and priorities, revealing blind spots and opportunities others miss.
      </Typography>
    ),
  },
  {
    id: 'who-we-are-better-solutions',
    icon: PaperWithDollarSignAndBarChart,
    title: 'Better solutions',
    contentAs: 'div',
    content: (
      <Typography disableBottomPadding>
        Our exclusive portfolio of financial products is designed to meet you where you are, at every stage in your life, identifying and addressing any gaps you might have.
      </Typography>
    ),
  },
  {
    id: 'who-we-are-better-outcomes',
    icon: BeachChairWithSun,
    title: 'Better outcomes',
    contentAs: 'div',
    content: (
      <Typography disableBottomPadding>
        Independent research analysis has shown that our comprehensive approach to planning can lead to better long&#45;term outcomes.<sup>1</sup>
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='who-we-are'
      headingText={<>What a better way to money&#174; means <WidowBlock>for you.</WidowBlock></>}
      cardDataArray={ITEMS}
      secondaryContent={
        <Row align='center'>
          <ColStyled align='center'>
            <Link
              id='who-we-are-understanding-product-cta-start-planning'
              variant='buttonLinkPrimary'
              themeType='lightTheme'
              linkUrl='/find-a-financial-advisor/'
              ariaLabel='Start planning with a financial advisor today.'>
              Let&#39;s start planning
            </Link>
          </ColStyled>
        </Row>
      }
    />
  );
};
